module.exports = __webpack_public_path__ + "static/media/janet-bannister.d1adf10d.jpg";